import React from 'react'

interface Props {
    children: React.ReactNode
}

const AppBox = ({ children }: Props) => {
    return (
        <div
            className={'bg-white rounded-xl px-6 py-6 w-full'}
            data-testid="view-box"
        >
            {children}
        </div>
    )
}

AppBox.displayName = 'AppBox'

export default AppBox
